import { Link } from 'react-router-dom';
import { videos } from '@/mocks/videos';
import { articles } from '@/mocks/articles';

export default function LatestUpdates() {
  const latestVideos = videos.slice(0, 8);
  const latestArticles = articles.slice(0, 4);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center justify-between mb-8">
              <div>
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
                  最新更新
                </h2>
                <p className="text-sm text-foreground-500 mt-2">每天都有新的精彩内容</p>
              </div>
              <Link
                to="/category/dianying"
                className="text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap flex items-center gap-1"
              >
                查看全部
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </Link>
            </div>

            <div className="space-y-3">
              {latestVideos.map((video, index) => (
                <Link
                  key={video.id}
                  to={`/article/${video.id}`}
                  className="flex items-center gap-4 p-3 bg-background-100/70 border border-background-200/50 rounded-lg hover:border-primary-300 transition-colors group cursor-pointer"
                >
                  <span className="text-sm font-bold text-foreground-300 w-6 text-center shrink-0">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                  <div className="w-28 h-16 shrink-0 rounded overflow-hidden">
                    <img
                      src={video.thumbnail}
                      alt={video.title}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="min-w-0 flex-1">
                    <h4 className="font-medium text-foreground-900 group-hover:text-primary-500 transition-colors truncate text-sm">
                      {video.title}
                    </h4>
                    <p className="text-xs text-foreground-400 mt-1 truncate">{video.description}</p>
                  </div>
                  <div className="hidden sm:flex items-center gap-2 text-xs text-foreground-400 shrink-0">
                    <span className="px-2 py-0.5 bg-secondary-100 text-secondary-700 rounded text-xs">
                      {video.category === 'dianying' ? '电影' :
                       video.category === 'dianshiju' ? '电视剧' :
                       video.category === 'jilupian' ? '纪录片' :
                       video.category === 'duanpian' ? '短片' :
                       video.category === 'dongman' ? '动漫' : '综艺'}
                    </span>
                    <span>{video.duration}</span>
                  </div>
                </Link>
              ))}
            </div>
          </div>

          <div>
            <div className="flex items-center justify-between mb-8">
              <div>
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
                  热门文章
                </h2>
                <p className="text-sm text-foreground-500 mt-2">深度解读影视佳作</p>
              </div>
            </div>

            <div className="space-y-4">
              {latestArticles.map((article) => (
                <Link
                  key={article.id}
                  to={`/article/${article.id}`}
                  className="block p-4 bg-background-100/70 border border-background-200/50 rounded-lg hover:border-primary-300 transition-colors group cursor-pointer"
                >
                  <div className="w-full h-36 rounded-md overflow-hidden mb-3">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <h4 className="font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors text-sm leading-snug">
                    {article.title}
                  </h4>
                  <p className="text-xs text-foreground-400 mt-1.5 line-clamp-2">{article.excerpt}</p>
                  <div className="flex items-center gap-3 mt-3 text-xs text-foreground-400">
                    <span>{article.date}</span>
                    <span>{article.readTime}</span>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}